import { useCallback } from 'react';

import { useConfigSlice } from '../store/slices/config/selectors';
import { getWindowObject } from '../utils/window';

import { openUrl } from './helpers/openUrl';
import { useLobbyURLConnected } from './useLobbyURLConnected';

export const useRedirectToLobbyCallbackConnected = (): (() => void) => {
  const lobbyURL = useLobbyURLConnected();
  const casinoConfig = useConfigSlice.casinoConfig();
  const windowObject = getWindowObject();

  return useCallback(() => {
    if (casinoConfig?.hideLobbyButtons) {
      if (casinoConfig.homeUrl) {
        openUrl(casinoConfig.homeUrl);
      } else {
        windowObject.location.reload();
      }
    } else {
      openUrl(lobbyURL);
    }
  }, [casinoConfig?.hideLobbyButtons, casinoConfig?.homeUrl, lobbyURL, windowObject.location]);
};
